export default __webpack_public_path__ + "static/media/NTEX CLASS-7 EXAM PATTERN 2026-27.6f01f576.pdf";